export const HorizonDots = ({...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={17}
            fill="none"
            {...props}
        >
            <path
                fill="#616161"
                d="M4 9.833c-.367 0-.68-.13-.942-.391a1.284 1.284 0 0 1-.391-.942c0-.367.13-.68.391-.942.261-.26.575-.391.942-.391s.68.13.941.391c.262.262.392.575.392.942s-.13.68-.392.942A1.284 1.284 0 0 1 4 9.833Zm4 0c-.367 0-.68-.13-.942-.391a1.284 1.284 0 0 1-.391-.942c0-.367.13-.68.391-.942.261-.26.575-.391.942-.391s.68.13.941.391c.262.262.392.575.392.942s-.13.68-.392.942A1.284 1.284 0 0 1 8 9.833Zm4 0c-.367 0-.68-.13-.942-.391a1.284 1.284 0 0 1-.392-.942c0-.367.131-.68.392-.942.261-.26.575-.391.942-.391s.68.13.941.391c.262.262.392.575.392.942s-.13.68-.392.942a1.284 1.284 0 0 1-.941.391Z"
            />
        </svg>
    );
}